export default {
  name: 'misc.occupation',
  key: 'occupation',
  attributes: {
    odd: {
      key: 'odd',
      name: 'entity.spaceStation.occupation.odd',
    },
    corpses: {
      key: 'corpses',
      name: 'entity.spaceStation.occupation.corpses',
    },
    observers: {
      key: 'observers',
      name: 'entity.spaceStation.occupation.observers',
    },
    minions: {
      key: 'minions',
      name: 'entity.spaceStation.occupation.minions',
    },
    scientist: {
      key: 'scientist',
      name: 'entity.spaceStation.occupation.scientist',
    },
  },
};
